/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: dashboard-livewidget
 *
 * (C) Copyright IBM Corp. 2019
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
  * THIS IS ONLY USED FOR THE SERVICEABILITY PANEL. WE DO NOT SUPPORT TRANSLATION FOR SERVICEABILITY
  * DO NOT SEND IT FOR TRANSLATION
*/
define([
	'i18n!./LwServiceabilityResources',
	'polyglot'
], function(ServiceabilityResources, Polyglot) {

	const poly = new Polyglot({
		phrases: ServiceabilityResources,
		allowMissing: true
	});

	class StringResources {

		/**
		 * Get the serviceability string resource for the given key and interpolation options
		 *
		 * @param key		The  key of the string to return
		 * @param {Object} [interpolationOptions] interpolation options (see poly.t documentation for details)
		 * @returns			The string to display
		 */
		get(key, interpolationOptions) {
			return poly.t(key, interpolationOptions);
		}
	}

	return new StringResources();
});
